/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, tab: NonNullable<unknown> }} Task_Flow_Link_TargetInputs */

const en_task_flow_link_target = /** @type {(inputs: Task_Flow_Link_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page} · ${i?.tab}`)
};

const pt_br2_task_flow_link_target = /** @type {(inputs: Task_Flow_Link_TargetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.page} · ${i?.tab}`)
};

/**
* | output |
* | --- |
* | "{page} · {tab}" |
*
* @param {Task_Flow_Link_TargetInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_flow_link_target = /** @type {((inputs: Task_Flow_Link_TargetInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Flow_Link_TargetInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_flow_link_target(inputs)
	return pt_br2_task_flow_link_target(inputs)
});